var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"https://rec.xuehusang.cn/sc_danmu.html","width":"100%","height":"98%","name":"sc记录","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }